export default {
    data() {
        return {
            showSearchField: false,
            timeout: null,
        }
    },
    methods: {
        startTimeout() {
            if (this.showFilterOptions) {
                this.timeout = setTimeout(() => {
                    this.showFilterOptions = false
                }, 3000)
            }
        },
        deleteTimeout() {
            clearTimeout(this.timeout)
            this.timeout = null
        },
    },
    beforeDestroy() {
        this.deleteTimeout()
    },
}